export const META_PIXEL_ID = '1795846768096238'

const CONTENT_PARAMS = {
  content_name: 'Gospel Sharing Mega Bundle',
  content_type: 'product',
}

type FbqFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[][]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: FbqFunction
    _fbq?: FbqFunction
    __mdsPixelInitialized?: boolean
  }
}

const SCRIPT_ID = 'meta-pixel-script'
const SCRIPT_SRC = 'https://connect.facebook.net/en_US/fbevents.js'

/** Loads the Meta Pixel once and fires PageView + ViewContent. */
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (window.__mdsPixelInitialized) return
  window.__mdsPixelInitialized = true

  if (!window.fbq) {
    const fbq: FbqFunction = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args)
      } else {
        fbq.queue?.push(args)
      }
    }
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []
    window.fbq = fbq
    if (!window._fbq) window._fbq = fbq
  }

  if (!document.getElementById(SCRIPT_ID)) {
    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.async = true
    script.src = SCRIPT_SRC
    document.head.appendChild(script)
  }

  window.fbq?.('init', META_PIXEL_ID)
  window.fbq?.('track', 'PageView')
  window.fbq?.('track', 'ViewContent', CONTENT_PARAMS)
}

/** Fires InitiateCheckout without navigating (for new-tab clicks). */
export function trackInitiateCheckoutOnly(): void {
  window.fbq?.('track', 'InitiateCheckout', CONTENT_PARAMS)
}

let checkoutInFlight = false

/** Fires InitiateCheckout, then continues to checkout. A lock prevents double-click duplicates. */
export function trackInitiateCheckout(href: string): void {
  if (typeof window === 'undefined') return
  if (checkoutInFlight) return
  checkoutInFlight = true

  window.fbq?.('track', 'InitiateCheckout', CONTENT_PARAMS)

  window.setTimeout(() => {
    window.location.href = href
    window.setTimeout(() => {
      checkoutInFlight = false
    }, 1500)
  }, 250)
}
